export const EncounterNotesDisplaySettings = (data) => {
    return {
      type: 'EncounterNotesDisplaySettings',
      payload: data
    }
}